import { useEffect, useRef, useState } from 'react';
import { startField } from './field';
import './Landing.css';

const EMAIL = 'info@validalpha.ai';

// Copies with the Clipboard API, falling back to a hidden textarea; returns false if neither works.
async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('aria-hidden', 'true');
    field.style.cssText = 'position:fixed;left:-9999px;top:0';
    document.body.appendChild(field);
    field.select();
    try {
      return document.execCommand('copy');
    } finally {
      field.remove();
    }
  }
}

export default function Landing() {
  const fieldRef = useRef(null);
  const emailRef = useRef(null);
  const copyRef = useRef(null);
  const [copy, setCopy] = useState({ label: 'Copy', status: '', n: 0 });   // n restarts the reset timer per click

  useEffect(() => startField(fieldRef.current), []);

  useEffect(() => {
    if (!copy.n) return undefined;
    const t = setTimeout(() => setCopy({ label: 'Copy', status: '', n: 0 }), 2000);
    return () => clearTimeout(t);
  }, [copy.n]);

  const copyEmail = async () => {
    let copied = false;
    try { copied = await copyText(EMAIL); } catch { copied = false; }
    copyRef.current.focus();
    if (copied) {
      setCopy(c => ({ label: 'Copied', status: 'Email address copied to clipboard', n: c.n + 1 }));
      return;
    }
    const range = document.createRange();
    range.selectNodeContents(emailRef.current);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    setCopy(c => ({ label: 'Select email', status: 'Please select and copy the email address manually', n: c.n + 1 }));
  };

  return (
    <>
      <canvas id="field" ref={fieldRef} aria-hidden="true" />
      <div className="veil" />
      <div className="grain" />
      <div className="frame">
        <header className="top">
          <span className="label where">ValidAlpha · Est. 2020</span>
        </header>
        <main className="hero">
          <div className="mark" role="img" aria-label="ValidAlpha" />
          <h1>Systematic trading firm in digital asset markets.</h1>
          <div className="rule" aria-hidden="true" />
          <p className="label">Research · Execution · Risk — engineered in-house</p>
        </main>
        <footer className="bottom">
          <div className="contact">
            <span className="intro">Institutional mandates, by introduction.</span>
            <div className="addr">
              <a id="email" ref={emailRef} href={`mailto:${EMAIL}`}>{EMAIL}</a>
              <button className="copy" id="copy" ref={copyRef} type="button" onClick={copyEmail}>{copy.label}</button>
              <span className="visually-hidden" id="copy-status" role="status">{copy.status}</span>
            </div>
          </div>
          <div className="legal">
            <small>For professional counterparties only. Nothing on this site is an offer or solicitation to buy or sell any financial instrument or investment service.</small>
            <span className="label entities copyright">ValidAlpha AB · ValidAlpha Ltd. · © {new Date().getFullYear()}</span>
          </div>
        </footer>
      </div>
    </>
  );
}
